// extracted by mini-css-extract-plugin
export default {"noPages":"content___noPages___a512b616","title":"content___title___dd8c8725","description":"content___description___b28c9a3b"};